import md5 from "md5";
import qs from "qs";
import * as persisters from "./persisters";
import {JsonApiClient} from "@/shared/client";

persisters.prepare();

export default {
  namespaced: true,
  state: {
    results: {}
  },
  getters: {},
  actions: {
    async getResults ({ commit, state }, { actionId, query }) {
      const hash = query ? md5(qs.stringify(query)) : "_default"

      if (typeof (state.results[actionId] || {})[hash] !== "undefined") {
        return state.results[actionId][hash]
      }

      const baseUrl = [window.location.protocol, "//", window.location.host].join("")

      const client = new JsonApiClient(baseUrl)

      const url = client.buildQueryUrl(`/api/${actionId}/teams`, query)

      const { data } = await client.get(url, {})

      // Extract all except data and included.
      const results = {
        jsonapi: data.jsonapi,
        data: client.deserialize(data),
        meta: data.meta,
        links: data.links,
      }

      commit("addResults", { results, actionId, hash })

      return results
    }
  },
  mutations: {
    addResults(state, { results, actionId, hash }) {
      if (!results || !actionId || !hash) return

      if (!state.results[actionId]) state.results[actionId] = {}
      if (!state.results[actionId][hash]) state.results[actionId][hash] = {}

      state.results[actionId][hash] = results
    }
  }
}
